/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  svgStyles?: string
  variant: 'liked' | 'not_liked'
}

const LikedSvg = (props: Props): JSX.Element => {
  const { svgStyles, variant, ...rest } = props
  const img = `
    <svg xmlns="http://www.w3.org/2000/svg" class="${
      props.svgStyles ?? ''
    }" width="21.097" height="25.021" viewBox="0 0 21.097 25.021">
      <g id="Component_192_12" data-name="Component 192 – 12" transform="translate(0.5 0.5)">
        <path id="Path_1768" data-name="Path 1768" d="M16.825,24.163l-5.57-2.37a2.621,2.621,0,0,0-2.091.017l-5.1,2.268a2.621,2.621,0,0,1-3.686-2.4V3A2.621,2.621,0,0,1,3,.375H17.851A2.621,2.621,0,0,1,20.472,3V21.751A2.621,2.621,0,0,1,16.825,24.163Z" transform="translate(-0.375 -0.375)" fill="${
          variant === 'liked' ? '#3582ce' : 'transparent'
        }" stroke="#3582ce" stroke-miterlimit="10" stroke-width="1"/>
        <path id="Path_1767" data-name="Path 1767" d="M17.766,12.562a.821.821,0,0,1,.791-.578.89.89,0,0,1,.821.578c.456,1.429,1,3.1,1.277,3.954a.849.849,0,0,0,.821.578h4.136a.863.863,0,0,1,.517,1.551c-1.216.882-2.646,1.916-3.376,2.433a.852.852,0,0,0-.3.973c.274.852.821,2.524,1.277,3.923a.854.854,0,0,1-1.308.973c-1.217-.882-2.616-1.916-3.346-2.463a.869.869,0,0,0-1,0c-.73.548-2.159,1.581-3.376,2.463a.822.822,0,0,1-.973,0,.931.931,0,0,1-.334-.973c.487-1.4,1-3.072,1.308-3.923a.913.913,0,0,0-.335-.973c-.73-.517-2.129-1.551-3.345-2.433a.822.822,0,0,1-.3-.943.84.84,0,0,1,.791-.608h4.167a.849.849,0,0,0,.821-.578c.274-.852.791-2.524,1.277-3.954" transform="translate(-8.521 -8.545)" fill="${
          variant === 'liked' ? '#fff' : '#3582ce'
        }" fill-rule="evenodd"/>
      </g>
    </svg>
  `
  return <div {...rest} dangerouslySetInnerHTML={{ __html: img }} />
}

export default LikedSvg
